<script>
    import {Router} from 'svelte-router-spa'
    import {routes} from './routes'
    import {onMount} from "svelte";
    import {translations} from "../../stores/translations";
    import {loginErrors} from "./stores/errors";
    import {enableSSO} from "./stores/settings";
	import {theme} from "./stores/theme";

	export let translationStrings;
    export let themeOptions;
    export let errors;
	export let singleSignOnEnabled;

    onMount(() => {
        $translations = translationStrings;
		$theme = themeOptions ?? {};
		$loginErrors = errors ?? {};
		$enableSSO = singleSignOnEnabled;
    });
</script>

<Router {routes}/>
